(function() {
  var AddMachine, DeleteDialog, ScrollHelper, ViewMachine,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DeleteDialog = App.loadClass("core::DeleteDialog");

  ScrollHelper = App.load("core::ScrollHelper");

  AddMachine = App.loadClass("grower::handlers/machinery/DialogAddMachinery_Handler");

  ViewMachine = App.loadClass("grower::handlers/machinery/DialogViewMachinery_Handler");

  exports.Machinery_Handler = (function(superClass) {
    extend(Machinery_Handler, superClass);

    function Machinery_Handler() {
      return Machinery_Handler.__super__.constructor.apply(this, arguments);
    }

    Machinery_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/grower/machinery/load-layout-machinery';
      this.layoutSelector = '#sidebar-content';
      this.dialogEdit = null;
      this.singleSubHandler = true;
      this.loadLayout();
      this.deleting = false;
      return this.selected = -1;
    };

    Machinery_Handler.prototype.deleteThis = function(e, obj) {
      var del, machinery_id, machinery_type;
      e.preventDefault();
      machinery_id = obj.parents('tr').data('machinery_id');
      machinery_type = obj.parents('tr').data('machinery_type');
      del = this.createSubHandler(DeleteDialog, 'Delete_Dialog_' + machinery_id);
      if (del) {
        del.saveUrl = 'backend/grower/machinery/delete/' + machinery_type;
        del.deleteTitle = 'Machinery';
        del.deleteMessage = 'this machine';
        del.deleteItemID = machinery_type + '#' + machinery_id;
        del.delayAfterSuccess = true;
        del.init();
        return del.successAction = function() {
          return this.parent.refresh();
        };
      }
    };

    Machinery_Handler.prototype.addMachinery = function(e, obj) {
      var add;
      e.preventDefault();
      add = this.createSubHandler(AddMachine);
      if (add) {
        return add.init();
      }
    };

    Machinery_Handler.prototype.editMachinery = function(e, obj, selector) {
      var edit, machinery_id, machinery_type, ths;
      e.preventDefault();
      this.afterHiddenMach(e, obj, selector);
      ths = this;
      machinery_id = obj.parents('tr').data('machinery_id');
      machinery_type = obj.parents('tr').data('machinery_type');
      ths.selected = machinery_id;
      obj.parents('tr').addClass('darken');
      edit = this.createSubHandler(ViewMachine, 'Grower.Machinery_Handler');
      if (edit) {
        edit.machinery_id = machinery_id;
        edit.machinery_type = machinery_type;
        edit.saveUrl = 'backend/grower/machinery/save';
        edit.wantEdit = true;
        edit.afterHidden = function() {
          if (!edit.refreshing) {
            return ths.afterHiddenMach(e, obj, selector, machinery_id);
          }
        };
        return edit.init();
      }
    };

    Machinery_Handler.prototype.viewMachinery = function(e, obj, selector) {
      var machinery_id, machinery_type, ths, view;
      e.preventDefault();
      ths = this;
      machinery_id = obj.parents('tr').data('machinery_id');
      machinery_type = obj.parents('tr').data('machinery_type');
      ths.selected = machinery_id;
      obj.parents('tr').addClass('darken');
      view = this.createSubHandler(ViewMachine, 'Grower.Machinery_Handler');
      if (view) {
        view.machinery_id = machinery_id;
        view.machinery_type = machinery_type;
        view.saveUrl = 'backend/grower/machinery/save';
        view.afterHidden = function() {
          if (!view.refreshing) {
            return ths.afterHiddenMach(e, obj, selector, machinery_id);
          }
        };
        return view.init();
      }
    };

    Machinery_Handler.prototype.afterHiddenMach = function(e, obj, selector, machinery_id) {
      var table;
      table = $(selector).find("#machinerylist");
      table.find('tr').removeClass('darken');
      return this.selected = -1;
    };

    Machinery_Handler.prototype.viewMachine = function(e, obj, selector) {
      var ths;
      ths = this;
      ths.destroySubHandler('Grower.Machinery_Handler', true);
      return ths.viewMachinery(e, $(obj), selector);
    };

    Machinery_Handler.prototype.afterLoadLayout = function(selector, data) {
      var msgwriter, table, ths;
      ths = this;
      msgwriter = App.sidebar.messageWriter();
      msgwriter.message_writer('success', 'Loaded!', true);
      table = $(selector).find("#machinerylist");
      $(selector).find('.table-container').resizr();
      ScrollHelper.make(table, {
        height: $(selector).find('.table-container').resizr('size'),
        forceHeight: true
      });
      $(window).bind('resize', debounce((function(_this) {
        return function(e) {
          return setTimeout(function() {
            var container, size;
            container = $(selector).find('.table-container');
            container.resizr('resize');
            size = container.resizr('size');
            size -= container.find('.dataTables_scrollHead').outerHeight();
            return container.find('.dataTables_scrollBody').height(size);
          }, 100);
        };
      })(this)));
      ScrollHelper.setSaveScroll("machinery", $(selector).find('.dataTables_scrollBody'));
      table.find('tbody tr .row-clickable').bind('click', function(e) {
        var selected, tr;
        if (!ths.deleting) {
          selected = ths.selected;
          tr = table.find('tr');
          if (tr != null ? tr.hasClass('darken') : void 0) {
            ths.destroySubHandler('Grower.Machinery_Handler', true);
            tr.removeClass('darken');
          }
          if ($(this).parents('tr').data('machinery_id') !== selected) {
            return ths.viewMachine(e, $(this), selector);
          } else {
            return ths.selected = -1;
          }
        }
      });

      /* machinery Details */
      table.find('.edit-machinery-details-btn').bind('click', function(e) {
        if (!ths.deleting) {
          return ths.editMachinery(e, $(this), selector);
        }
      });

      /* Delete machinery */
      table.find('.delete-machinery-btn').bind('click', function(e) {

        /*nav_selected_handler.activeSubHandler.deleteMachinery(e,$(this)) */
        return ths.deleteThis(e, $(this), selector);
      });

      /* send the call to actually retrieve/populate the list */
      $(selector).find('.add-btn').bind('click', function(e) {
        return ths.addMachinery(e, $(this));
      });

      /* Init multi-deletion */
      $(selector).find(".btn-multidelete").multidelete({
        delUrl: 'machinery/multi-delete',
        dataKey: 'machinery_id',
        dataName: 'name',
        onStart: function() {
          table.find('tr').removeClass('darken');
          ths.destroyAllSubHandlers();
          return ths.deleting = true;
        },
        afterHidden: function() {
          return ths.deleting = false;
        }
      });
      return $(selector).find('.btn-multidelete').keypress(function(e) {
        if (e.which === 13) {
          return e.preventDefault();
        }
      });
    };

    return Machinery_Handler;

  })(Handler);

}).call(this);
